module.exports = __webpack_public_path__ + "static/client_jim_vitek-bfabd33de2201bb04c6fd2f5f182649d.png";